import React from 'react';
import styled from 'styled-components';
import { CategoryTitleSection } from '@/react/components/CategoryTitleSection';
import { Box, useI18nContext } from '@procore/core-react';
import CategoryCard from './CategoryCard';

const GridContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const TOP_CATEGORIES = [
  {
    nameKey: 'topCategories.documentManagement.name',
    descriptionKey: 'topCategories.documentManagement.description',
    image_path: 'categories/document-management.png',
    slug: '/categories/document_management',
  },
  {
    nameKey: 'topCategories.accounting.name',
    descriptionKey: 'topCategories.accounting.description',
    image_path: 'categories/accounting.png',
    slug: '/categories/accounting',
  },
  {
    nameKey: 'topCategories.fieldCommunications.name',
    descriptionKey: 'topCategories.fieldCommunications.description',
    image_path: 'categories/field-communications.png',
    slug: '/categories/field_communications',
  },
];

export const TopCategories = () => {
  const i18n = useI18nContext();

  return (
    <Box gap="md">
      <CategoryTitleSection
        title={i18n.t('topCategories.section.title')}
        subtitle={i18n.t('topCategories.section.subtitle')}
      />
      <GridContainer>
        {TOP_CATEGORIES.map((category) => (
          <CategoryCard key={category.slug} category={category} />
        ))}
      </GridContainer>
    </Box>
  );
};
